import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Error404 from '../../Page/Error404';
import DashboardPage from '../../Page/SelectCarPage';
import SelectCarPage from '../../Page/SelectCarPage';
import ChekoutPage from '../../Page/ChekoutPage';
import SignUpPage from '../../Page/SignUpPage';
import QuickSignup from '../../Page/QuickSignup';

const allRoutes = [
  { url: "", component: <DashboardPage /> },
  { url: "/dashboard", component: <SelectCarPage /> },
  { url: "/manage-rooms", component: <DashboardPage /> },
  { url: "/car-booking", component: <ChekoutPage /> },
  { url: "/signup", component: <SignUpPage /> },
  { url: "/quick-signup", component: <QuickSignup /> },
  
];

const AppRoutes = () => {
  return (
    <Routes>
      {allRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.url}
          element={route.component}
        />
      ))}

s      <Route
        path="/"
        element={<Navigate to="/hc-book" replace />}
      />
      {/* Handle 404 */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRoutes;